module.exports = __webpack_public_path__ + "static/media/clothing-fashion.fe277ea4.svg";